// const Mutations = Object.freeze({
// });

export const Actions = Object.freeze({
	CHANGE_PASSWORD: 'myProfile/CHANGE_PASSWORD',
});

export const Getters = Object.freeze({});
import dataService from '../../../../services/data/userContextDataService';
import { GeneralActions } from '../../../actions';
export default {
	state: {},
	mutations: {},
	actions: {
		[Actions.CHANGE_PASSWORD]({ dispatch }, password) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.changePassword(password)
					.then(() => {
						resolve();
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve();
					})
					.finally(() => {
						dispatch(GeneralActions.LOADING, false);
						resolve();
					});
			});
		},
	},
	getters: {},
};
